import { useRouter } from "next/router";
import Modal from "../ui/modal";
import SearchPrompt from "../ui/search-prompt";
import SearchMenuItems from "../ui/search-menu-items";

const SearchModal = ({toggleModal}) => {
  const router = useRouter();
  function handleSearch(e) {
    e.preventDefault();
  }

  function handleCloseModal() {
    router.push("/");
  }
  return (
    <>
      <Modal handleClick={toggleModal}>
        <SearchPrompt
          handleClick={toggleModal}
          handleSubmit={handleSearch}
        >
          <SearchMenuItems/>
        </SearchPrompt>
      </Modal>
    </>
  );
};

export default SearchModal;
